import lightGallery from "lightgallery";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
const galleryArray = document.querySelectorAll(".js-jumbotron-lightgallery");

galleryArray.forEach((element) => {
  lightGallery(element, {
    speed: 500,
    plugins: [lgVideo],
    videojs: true,
    videojsOptions: {
      muted: true,
    },
    licenseKey: "8C1D605B-6C6F4022-9AE1B332-5383DA54",
  });
});

window.playJumbotronVideo = function (event, button) {
  // Find the closest '.js-jumbotron-lightgallery' element relative to the clicked button
  var videoLink = button.closest(".js-jumbotron-lightgallery a");

  // If the closest method doesn't find the element, try finding any '.js-jumbotron-lightgallery' in the DOM
  if (!videoLink) {
    videoLink = document.querySelector(".js-jumbotron-lightgallery a");
  }

  if (videoLink) {
    // Emulate a click on that element
    event.preventDefault();
    videoLink.click();
  } else {
    console.error(
      'No element with class "js-jumbotron-lightgallery" found nearby.'
    );
  }
};
